import React from 'react';

import TextileDesignThemes from './TextileDesignThemes';

export default (props: any) => <TextileDesignThemes {...props} detail={true} />;
